import MaintenanceDevices from 'features/Integrations/features/MaintenanceDevices/index.web';

const DeviceMaintenanceRoute = () => <MaintenanceDevices />;

export default DeviceMaintenanceRoute;
